'use strict';
import template from './listadoMunicipio.html';
import controller from './listadoMunicipio.controller';

const ListadoBonoMunicipiosComponent = {
  controller,
  template
};

export default ListadoBonoMunicipiosComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/listadoMunicipio/listadoMunicipio.component.js